import React from "react";

const IpNetwork = () => {
    return (
        <div className="doc_page_cont">
            <p className="doc_page_cont_title">IP Network Access</p>

            <p className="doc_page_cont_paragraph">
                IP Network Access lets you define which IP addresses are permitted to access your <strong>Erioon</strong> project resources. 
                For enhanced security, <strong>Erioon only allows connections from IPs or ranges listed in your project's IP Access List</strong>.
            </p>

            <p className="doc_page_cont_paragraph">
                Each IP Access List entry must be either a single IPv4 address (e.g., <code>192.0.2.1</code>) or a CIDR-notated range (e.g., <code>192.0.2.0/24</code>).
                Any connection attempt from outside this list will be blocked.
            </p>

            <p className="doc_page_cont_subtitle">Adding an IP Address</p>
            <p className="doc_page_cont_paragraph">
                To allow an IP address or range:
            </p>
            <ol className="list_cont_doc">
                {/* <li>Log in to your <a href="https://www.erioon.com/login" className="text-blue-400">Erioon Dashboard</a> and select your project</li> */}
                <li>Log in and select your project</li>
                <li>Navigate to the <strong>Network</strong> section</li>
                <li>Click '<strong><i className="fa-solid fa-plus"></i> Create</strong>'</li>
                <li>Enter the IP address or CIDR range you want to allow</li>
                <li>Click <strong>Save</strong> to add it to your Access List</li>
            </ol>

            <p className="doc_page_cont_subtitle">Best Practices</p>
            <ul className="list_cont_doc">
                <li>Only add IPs you fully trust, such as backend servers or secure developer environments</li>
                <li>Use CIDR notation to allow controlled ranges (e.g., <code>203.0.113.0/28</code>)</li>
                <li>Update the IP list when team infrastructure or hosting providers change</li>
                <li>Do not use <code>0.0.0.0/0</code> in production as it opens access to all networks</li>
            </ul>
        </div>
    );
};

export default IpNetwork;
